import * as React from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import { renderTextWithFootnotesReferences } from '../feature-service-types';

const DisclaimersContainer = styled.div``;

export interface DisclaimersProps {
  disclaimers?: string[];
}

export const Disclaimers: React.FC<DisclaimersProps> = ({ disclaimers }) => {
  if (!disclaimers || !disclaimers.length) return null;

  return (
    <DisclaimersContainer>
      {disclaimers?.map((disclaimer, i) => (
        <Text
          key={`disclaimer${i}`}
          variant={{ type: 'copy', order: '3', style: 'normal' }}
          margin={['var(--spacing-relative-xs)', 0, 0, 0]}
        >
          {renderTextWithFootnotesReferences(disclaimer)}
        </Text>
      ))}
    </DisclaimersContainer>
  );
};

Disclaimers.displayName = 'Disclaimers';
